import { createSlice } from "@reduxjs/toolkit";
const initialFeatureFlag = {};

const featureFlagSlice = createSlice({
    name: "featureFlagsReducer",
    initialState: { ...initialFeatureFlag },
    reducers: {
        setFeatureFlag: (state, action): any => {
            return {
                ...action.payload,
            };
        },
        resetFeatureFlag: (state: any): any => {
            return {
                ...initialFeatureFlag,
            };
        },
    },
});

export const { setFeatureFlag, resetFeatureFlag } =
    featureFlagSlice.actions;
export default featureFlagSlice.reducer;
